import { useEffect, useState } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { TIMEZONE } from "../../constans";
import { isMarkedShift } from "../../helpers/scheduleWorkingDaysLookup";

dayjs.extend(utc);
dayjs.extend(timezone);

const norm = (s) => (s || "").toLowerCase();
// "Директ"/"Дірект" (обидва написання зустрічаються) підходять, "Директор"/"Діректор" — ні (посада, а не локація).
const isDirectGroup = (group) => /д[іи]рект(?!ор)/.test(norm(group));
const isShowroomGroup = (group) => norm(group).includes("шоурум");

export const WhoWorksToday = () => {
    const [status, setStatus] = useState("loading");
    const [direct, setDirect] = useState([]);
    const [showroom, setShowroom] = useState([]);

    useEffect(() => {
        let cancelled = false;
        const today = dayjs().tz(TIMEZONE);
        const ym = today.format("YYYY-MM");
        const dayNum = String(today.date());

        (async () => {
            setStatus("loading");
            try {
                const res = await fetch(`/api/schedule/month?ym=${encodeURIComponent(ym)}`, {
                    credentials: "include",
                });
                if (!res.ok) throw new Error(res.statusText);
                const data = await res.json();
                if (cancelled) return;

                const shifts = data.shifts || {};
                const participants = data.participants || [];
                const todayState = (userId) => shifts[String(userId)]?.[dayNum];
                const isWorkingToday = (userId) => isMarkedShift(todayState(userId));
                /** «Імʼя (1 зміна)» — коли день поділено на зміни. */
                const nameWithShift = (p) => {
                    const st = todayState(p.userId);
                    if (st === "shift1") return `${p.displayName} (1 зміна)`;
                    if (st === "shift2") return `${p.displayName} (2 зміна)`;
                    return p.displayName;
                };

                setDirect(
                    participants
                        .filter((p) => isDirectGroup(p.group) && isWorkingToday(p.userId))
                        .map(nameWithShift)
                );
                setShowroom(
                    participants
                        .filter((p) => isShowroomGroup(p.group) && isWorkingToday(p.userId))
                        .map(nameWithShift)
                );
                setStatus("ok");
            } catch {
                if (cancelled) return;
                setStatus("error");
            }
        })();

        return () => {
            cancelled = true;
        };
    }, []);

    if (status !== "ok") return null;

    const directText = direct.length > 0 ? direct.join(", ") : "нікого";
    const showroomText = showroom.length > 0 ? showroom.join(", ") : "нікого";

    return (
        <>
            <div className="orders-page-who-works-today d-none d-lg-block text-muted small px-3 pt-2 pb-1">
                Сьогодні працюють —{" "}
                <strong className="text-body">Директ:</strong> {directText}
                {" · "}
                <strong className="text-body">Шоурум:</strong> {showroomText}
            </div>
            <div className="orders-page-who-works-today orders-page-who-works-today--mobile d-lg-none text-muted small px-3 pt-2 pb-1">
                <div>Сьогодні працюють:</div>
                <div><strong className="text-body">Директ:</strong> {directText}</div>
                <div><strong className="text-body">Шоуруми:</strong> {showroomText}</div>
            </div>
        </>
    );
};

export default WhoWorksToday;
